import { z } from 'zod';
import { auditFieldsSchema, idSchema } from './common.js';
/**
 * Centro de custo hierárquico.
 *
 * É por aqui que se responde "quanto custou cada centro de custo": todo
 * lançamento financeiro e toda saída de estoque apontam para um centro de
 * custo ANALÍTICO (folha da árvore).
 */
export const COST_CENTER_KINDS = ['OBRA', 'OPERACAO', 'ADMINISTRATIVO'];
export const costCenterKindSchema = z.enum(COST_CENTER_KINDS);
export const COST_CENTER_KIND_LABELS = {
    OBRA: 'Obra',
    OPERACAO: 'Operação',
    ADMINISTRATIVO: 'Administrativo',
};
export const costCenterSchema = auditFieldsSchema.extend({
    id: idSchema,
    companyId: idSchema,
    code: z.string(),
    name: z.string(),
    kind: costCenterKindSchema,
    parentId: idSchema.nullable(),
    /** Caminho materializado (`1.2.3`) — ordena e filtra a subárvore inteira. */
    path: z.string(),
    level: z.number().int(),
    /** Sintético agrupa; analítico é o único que aceita lançamento. */
    isAnalytic: z.boolean(),
    isActive: z.boolean(),
    notes: z.string().nullable(),
});
export const costCenterInputSchema = z.object({
    code: z
        .string()
        .trim()
        .min(1, 'Informe o código')
        .max(30)
        .regex(/^[0-9A-Za-z.-]+$/, 'Use apenas letras, números, ponto e hífen'),
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    kind: costCenterKindSchema.default('OBRA'),
    parentId: idSchema.optional().nullable(),
    isAnalytic: z.boolean().default(true),
    isActive: z.boolean().default(true),
    notes: z.string().trim().max(500).optional().nullable(),
});
/**
 * Árvore recursiva. O `id` no registro global do Zod é o que permite ao gerador
 * de OpenAPI emitir um `$ref` nomeado — sem ele, um schema recursivo vira uma
 * referência pendente e o client não compila.
 */
export const costCenterTreeSchema = z
    .lazy(() => costCenterSchema.extend({ children: z.array(costCenterTreeSchema) }))
    .meta({ id: 'CostCenterNode' });
//# sourceMappingURL=cost-center.js.map